import { APP_ROUTES } from "../constants";

export const VideoUtil = {
  buildHomepageDetailPath,
  buildResourceDetailPath
};

function buildHomepageDetailPath(videoCode: string): string {
  return videoCode ? APP_ROUTES.RESOURCE.VIDEO.VIDEOHOMEPAGE.DETAIL.replace(":videoCode", videoCode) : APP_ROUTES.RESOURCE.VIDEO.VIDEOHOMEPAGE.BASE;
}

function buildResourceDetailPath(videoCode: string): string {
  return videoCode ? APP_ROUTES.RESOURCE.VIDEO.VIDEORESOURCE.DETAIL.replace(":videoCode", videoCode) : APP_ROUTES.RESOURCE.VIDEO.VIDEORESOURCE.BASE;
}